import { useEffect } from "preact/hooks";
import { useComputed } from "@preact/signals";
import { ExpenseViewStatus, useApp } from "~/core";
import { SingleWidgetProps } from "../interfaces";

const ACTIVE_STATUSES = [
    ExpenseViewStatus.NotSubmitted,
    ExpenseViewStatus.Submitted,
    ExpenseViewStatus.Approved,
    ExpenseViewStatus.BookedUnpaid,
];

const useWidget = ({}: SingleWidgetProps) => {
    const { api } = useApp();
    const loading = useComputed(() => api.expense.loading.value);
    const expenses = useComputed(() =>
        api.expense.expenses.value.filter((e) =>
            ACTIVE_STATUSES.includes(e.status),
        ),
    );

    useEffect(() => {
        api.expense.listen();
    }, [api]);

    return { loading, expenses };
};

export default useWidget;
